import { render, staticRenderFns } from "./ChooseTariffModal.vue?vue&type=template&id=655cf457&scoped=true&"
import script from "./ChooseTariffModal.vue?vue&type=script&lang=js&"
export * from "./ChooseTariffModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseTariffModal.vue?vue&type=style&index=0&id=655cf457&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655cf457",
  null
  
)

export default component.exports